import * as React from "react";
import {Box, Container, TextField, Typography} from "@mui/material";
import {styled} from '@mui/system';
import {useSelector} from "react-redux";
import {IBasicInfo} from "../ProjectBasicInfo";


// Create a custom styled TextField with bold placeholder text
export const BoldPlaceholderTextField = styled(TextField)({
    '& .MuiInputBase-input::placeholder': {
        fontWeight: '500',
        color: '#2c2b2b',
        opacity: 1,
        fontSize: '16px',
    },
});
export const HeadStyleTypography = styled(Typography)(() => ({
    fontSize: '20px',
    fontWeight: 'bold',
}));

export const TitleStyleTypography = styled(Typography)(() => ({
    fontSize: '24px',
    fontWeight: 'bold',
}));

const ProjectBasicInfoPDF = () => {

    const today = new Date().toISOString().slice(0, 10); // Get today's date in YYYY-MM-DD format
    const summary: IBasicInfo = useSelector((state: any) => state.projectInfo.basicInfo)

    return (
        <React.Fragment>
            <Container maxWidth="lg">
                <Box my={4}>
                    <HeadStyleTypography>Report Generated on:</HeadStyleTypography>

                    <TextField
                        fullWidth
                        variant="standard"
                        margin="normal"
                        defaultValue={today}
                        InputProps={{
                            readOnly: true,
                            // style: {fontWeight: 'bold'} // Apply bold style to the input text
                        }}
                    />

                    <TitleStyleTypography align="center">
                        {summary?.title}
                    </TitleStyleTypography>

                    <Box my={2}>
                        <HeadStyleTypography>Province:</HeadStyleTypography>
                        <BoldPlaceholderTextField
                            fullWidth
                            variant="standard"
                            margin="normal"
                            placeholder={summary?.region || ""}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Box>

                    <Box my={2}>
                        <HeadStyleTypography>Executing Agency</HeadStyleTypography>
                        <BoldPlaceholderTextField
                            fullWidth
                            variant="standard"
                            margin="normal"
                            placeholder={summary?.exec_agency || ""}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Box>

                    <Box my={2}>
                        <HeadStyleTypography>Donor Agency:</HeadStyleTypography>
                        <BoldPlaceholderTextField
                            fullWidth
                            variant="standard"
                            margin="normal"
                            placeholder={summary?.donor || ""}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Box>

                    <Box my={2}>
                        <HeadStyleTypography>Project Summary:</HeadStyleTypography>

                        <textarea
                            style={{
                                width: '100%',
                                margin: '16px 0',
                                padding: '12px',
                                fontSize: '16px',
                                fontWeight: '500',
                                color: '#2c2b2b',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                resize: 'vertical',
                                backgroundColor: '#f9f9f9'
                            }}
                            value={summary?.description}
                            readOnly
                        />
                    </Box>
                </Box>
            </Container>
        </React.Fragment>
    );
};

export default ProjectBasicInfoPDF;
